import { render, staticRenderFns } from "./TipoTrpExibir.vue?vue&type=template&id=17b5c620&"
import script from "./TipoTrpExibir.vue?vue&type=script&lang=js&"
export * from "./TipoTrpExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports